var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08317 12.2225C7.08317 13.2964 7.95373 14.167 9.02761 14.167H10.8332C11.9838 14.167 12.9165 13.2343 12.9165 12.0837C12.9165 10.9331 11.9838 10.0003 10.8332 10.0003H9.1665C8.01591 10.0003 7.08317 9.06759 7.08317 7.91699C7.08317 6.7664 8.01591 5.83366 9.1665 5.83366H10.9721C12.0459 5.83366 12.9165 6.70422 12.9165 7.7781M9.99984 4.58366V5.83366M9.99984 14.167V15.417M18.3332 10.0003C18.3332 14.6027 14.6022 18.3337 9.99984 18.3337C5.39746 18.3337 1.6665 14.6027 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003Z",
    stroke: "#040B10",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyDollarCircle);
export default __webpack_public_path__ + "static/media/currency-dollar-circle.f854e29da4f50270de4d0c0a16d69734.svg";
export { ForwardRef as ReactComponent };